import React, {Component} from "react";
import AppActions from "../flux/AppActions";
import Toast from "../toast";
import AjaxLoader from "../components/AjaxLoader";
import ShoppingList from "../components/ShoppingList";

const locale = (typeof (window.AppWizardLocale) !== 'undefined' ? window.AppWizardLocale : false);
if (!locale) {
    throw new Error('Error: Locale not loaded');
}

const $ = window.jQuery;
const toast = new Toast();

class PageShoppingListBeefeaterIsHot extends Component {
    constructor(props) {
        super(props);

        this.inputRef = React.createRef();

        this.state = props.app.state;

        this.__getShoppingList = this.__getShoppingList.bind(this);
    }

    componentDidMount() {
        AppActions.updatePage('shoppingListBeefeaterIsHot');
        this.__getShoppingList(this.props);
    }

    __goToCocktailsPage(e) {
        e.preventDefault();
        AppActions.updatePage('cocktailsBeefeaterIsHot');
    }

    __getShoppingList(props) {
        window.scrollTo({
            top: 0
        });

        this.setState({
            loading: true
        });

        let locale = props.locale;
        let {ajaxurl, nonce_name, nonce_value} = locale;
        let self = this;
        let ajaxConfig = {
            url: ajaxurl,
            method: "POST",
            timeout: 29000,
            cache: false,
            async: true,
            data: {
                action: "bth_ajax",
                request: "get_shopping_list",
                post_id: props.app.state.cocktail.id,
                [nonce_name]: nonce_value
            }
        };

        $.ajax(ajaxConfig)
            .done(function (r) {
                if (r) {
                    if (r.success) {
                        if (r.data) {
                            self.setState({
                                cocktail: r.data.cocktail,
                                page_data: r.data.items,
                                loading: false
                            });
                        } else {
                            toast.show(locale.texts.empty_response, Toast.TYPE_ERROR);
                        }
                    } else {
                        if (r.data) {
                            toast.show(r.data, Toast.TYPE_ERROR);
                        } else {
                            toast.show(locale.texts.empty_response, Toast.TYPE_ERROR);
                        }
                    }
                } else {
                    toast.show(locale.texts.no_response, Toast.TYPE_ERROR);
                }
            })
            .fail(function (x, s, e) {
                toast.show(e, Toast.TYPE_ERROR);
            })
            .always(function () {
                self.setState({
                    loading: false
                });
            });
    }

    __saveShoppingListAuthenticated(e) {
        e.preventDefault();

        //#! Prevent repetitive clicks
        if ( this.state.loading ) {
            return false;
        }

        this.setState( {
            loading: true
        } );

        let locale = this.props.locale;
        let { ajaxurl, nonce_name, nonce_value } = locale;
        let self = this;

        let ajaxConfig = {
            url: ajaxurl,
            method: "POST",
            timeout: 29000,
            cache: false,
            async: true,
            data: {
                action: "bth_ajax",
                request: "save_user_shopping_list",
                post_id: this.state.cocktail.id,
                brand_id: this.state.cocktail.brand_ids, // this.state.cocktail.brand_id,
                campaign: this.props.app.props.campaign,
                [nonce_name]: nonce_value
            }
        };

        $.ajax( ajaxConfig )
            .done( function (r) {
                if ( r.success ) {
                    //toast.show( locale.texts.shopping_list_saved, Toast.TYPE_SUCCESS );
                    alert(locale.texts.shopping_list_saved);
                }
                else {
                    //toast.show( locale.texts.no_response, Toast.TYPE_ERROR );
                    alert(locale.texts.no_response);
                }
            } )
            .fail( function (x, s, e) {
                toast.show( e, Toast.TYPE_ERROR );
            } )
            .always( function () {
                self.setState( {
                    loading: false
                } );
            } );
    }

    render() {
        const locale = this.props.locale;
        const page_data = (this.state.page_data.length ? this.state.page_data : false);
        const cocktail = this.state.cocktail ? this.state.cocktail : null;

        return (
            <React.Fragment>
                <header className="header header--cocktails-page d-flex flex-wrap justify-content-center align-items-start align-items-md-center">
                    <div className="header__background-image d-none d-md-block"
                         style={{backgroundImage: `url('${locale.img_uri}/afisare-cocktails/beefeater-is-hot-cocktails-desktop.jpg')`}}>
                    </div>
                    <div className="header__background-image d-block d-md-none"
                         style={{backgroundImage: `url('${locale.img_uri}/afisare-cocktails/beefeater-is-hot-cocktails-mobile.jpg')`}}>
                    </div>
                    <div className="header__text text-left">
                        <h2 className="header__text-title-small text-center text-md-left">
                            TU AI ALES BĂUTURILE, NOI ÎȚI FACEM
                        </h2>
                        <h1 className="header__text-title text-center text-md-left">
                            LISTA DE<br/>
                            CUMPĂRĂTURI
                        </h1>
                    </div>
                </header>

                <section className="shopping-list">
                    <h3 className="shopping-list__heading text-center">
                        ÎȚI RECOMANDĂM CELE MAI TARI COCKTAILURI
                    </h3>

                    <div className="shopping-list__cocktails d-flex flex-column flex-md-row flex-wrap justify-content-center align-items-start">
                        <article className="shopping-list__cocktail col-12 d-flex flex-wrap">
                            <div className="cocktail__info col-12 col-md-5 text-center">
                                <div className="cocktail__image-box d-flex flex-column justify-content-end align-items-center">
                                    <img src={this.state.cocktail.image_url} alt="" className="cocktail__image"/>
                                    <h3 className="cocktail__name text-center" dangerouslySetInnerHTML={{__html: this.state.cocktail.title}}/>
                                </div>
                            </div>
                            <div className="cocktail__recipe-container col-12 col-md-7">
                                <h3 className="cocktail__recipe__heading">LISTĂ DE CUMPĂRĂTURI</h3>

                                {this.state.loading && <AjaxLoader/>}

                                {page_data && <ShoppingList cocktail={cocktail} items={page_data} app={this.props.app} locale={locale}/>}

                                {locale.is_logged_in ?
                                    <a onClick={this.__saveShoppingListAuthenticated.bind( this )}
                                       href="#"
                                       className="button button--xl button--save-shopping-list">
                                        {locale.texts.save}
                                    </a>
                                    :
                                    <div>
                                        <p className="shopping-list__login-cta">{locale.texts.login_cta}</p>
                                        <a href={locale.site_login_page_url} className="button button--xl button--shopping-list-login">Autentificare</a>
                                    </div>
                                }
                            </div>
                        </article>
                    </div>
                    <div className="cocktails__pagination text-center">
                        <p className="cocktails__pagination-text">
                            Mergi înapoi la cocktails
                        </p>
                        <a onClick={this.__goToCocktailsPage.bind(this)} href="#" className="cocktails__pagination-link">
                            <img src={locale.img_uri + 'afisare-cocktails/back-button.svg'} alt=""/>
                        </a>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default PageShoppingListBeefeaterIsHot;
